export const BSC = 56
export const ARBITRUM = 42161
export const AVALANCHE = 43114
export const CRONOS = 25
export const BESC = 2372

export const addresses = {
    [ARBITRUM]: {
        MONEY: '0xfc5A1A6EB076a2C7aD06eD22C90d7E710E35ad0a',
        BTC: '0x2f2a2543b76a4166549f7aab2e75bef0aefc5b0f',
        ETH: '0x82af49447d8a07e3bd95bd0d56f35241523fbab1',
        LINK: '0xf97f4df75117a78c1a5a0dbb814af92458539fb4',
        UNI: '0xfa7f8980b0f1e64a2062791cc3b0871572f1f7f0',
        DAI: '0xda10009cbd5d07dd0cecc66161fc93d7c9000da1',
        RewardReader: '0x8BFb8e82Ee4569aee78D03235ff465Bd436D40E0',
        MLP: '0x4277f8F2c384827B5273592FF7CeBd9f2C1ac258',
        MlpManager: '0x321F653eED006AD1C29D174e17d96351BDe22649'
    },

    [AVALANCHE]: {
        MONEY: '0xfc5a1a6eb076a2c7ad06ed22c90d7e710e35ad0a',
        AVAX: '0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7',
        ETH: '0x49d5c2bdffac6ce2bfdb6640f4f80f226bc10bab',
        BTC: '0x50b7545627a5162f82a992c33b87adc75187b218',
        RewardReader: '0x04Fc11Bd28763872d143637a7c768bD96E44c1b6',
        MLP: '0x01234181085565ed162a948b6a5e88758CD7c7b8',
        MlpManager: '0xe1ae4d4b06A5Fe1fc288f6B4CD72f9F8323B107F'
    },

    [CRONOS]: {
        MONEY: '0x1542ba4ca0fb6d1b4476a933b292002fd1959a52',
        CRO: '0x5c7f8a570d578ed84e63fdfa7b1ee72deae1ae23',
        BTC: '0x062e66477faf219f25d27dced647bf57c3107d52',
        ETH: '0xe44fd7fcb2b1581822d0c862b68222998a0c299a',
        RewardReader: '0x4f7b5e7500f0dd8ac315acc249350f89346cb9c9',
        MLP: '0xb4d8d3b6b165091bf7a03744442960c771cce3f0',
        MlpManager: '0x32889dd3209b32fec343a4c8081f54abeffc06b8'
    },

    [BESC]: {
        MONEY: '0xf794E0B0c0a91099ccAcac296193e04Fb860442a',
        WBESC: '0x33e22F85CC1877697773ca5c85988663388883A0',
        RewardReader: '0x4304709155a34D760f31a557D6012c93F6b6078b',
        MLP: '0xFc80AF0eA8d75b34f52357310dFf81E47d6b08a0', // SynthMLP (single pool)
        MlpManager: '0x3ccF047bEfDb42BA90544f0eA78f3B4fcDCb1b23' // SynthMlpManagerV2
    },

    [BSC]: {
        MONEY: '0x4ffe5ec4d8b9822e01c9e49678884baec17f60d9',
        BNB: '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c',
        BTC: '0x7130d2a12b9bcfae4f2634d864a1ee1ce3ead9c',
        ETH: '0x2170ed0880ac9a755fd29b2688956bd959f933f8',
        RewardReader: '0xa8433bc9dcb49875d218a15ef1d6aac4d0076c8a',
        MLP: '0x14c7e28d4dd0d593cb2d481a7cbaf462b18a477a',
        MlpManager: '0x667e43e32372696c27b7ab72d435bc9261f35e01'
    }
}

export function getAddress(chainId, key) {
    if (!(chainId) in addresses) {
        throw new Error(`Unknown chain ${chainId}`)
    }
    if (!(key in addresses[chainId])) {
        throw new Error(`Unknown address key ${key}`)
    }
    return addresses[chainId][key]
}
